import styled from 'styled-components';
import MFlexbox from '../../atoms/MFlexbox';

export const StyledProductActionButtonsCon = styled(MFlexbox)`
  &.mr-product-item__actions--vertical {
    width: fit-content;
    max-width: 200px;
  }

  &.mr-product-item__actions--vertical > * {
    max-width: 100%;
  }

  &.mr-product-item__actions--vertical-full-width {
    width: auto;
    max-width: 100%;
  }

  &.mr-product-item__actions--vertical-center .mr-actions--absolute-width {
    margin-right: auto;
    margin-left: auto;
  }

  &.mr-product-item__actions--horizontal-full-width {
    width: 100%;
    max-width: 100%;
  }

  &.mr-product-item__actions--horizontal > *:not(.mr-actions--absolute-width) {
    min-width: fit-content;
    flex: 1 1 auto;
  }

  & .mr-actions__action-filler-con--hidden,
  .mr-product-item__action-filler,
  .mr-actions__variant-selector--hidden {
    visibility: hidden;
    height: 0px;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    border-top: 0px solid transparent !important;
    border-bottom: 0px solid transparent !important;
  }

  & .mr-product-item__action-filler--vertical,
  .mr-actions__action-filler-con--hidden {
    margin-top: -8px;
  }

  & .mr-actions__action-filler-con > * {
    width: 100%;
  }

  & .mr-actions__variant-selector--hidden {
    min-width: 0px;
    width: 0px;
  }

  & .mr-added-variants-chips__variants-list {
    display: flex;
    gap: 4px;
  }
`;
